import { RefString, RefSerializer, Select, HidingContentSwitcher, MultilineInput, JsonViewer } from "@tblabs/truffle";
import { Center } from "../../../Components/Utils/Center";
import { DangerButton } from "../../../Components/Utils/DangerButton";
import { SmallHeader } from "../../../Components/Utils/SmallHeader";
import { OrdersManager } from "../../../Services/Storage/OrdersManager";
import { Page } from "../../Page";
import { InfoBox } from "../../../Components/InfoBox";
import { Order } from "../../../Models/Order";


export class AdminOrderRawEditPage extends Page
{
    private view = new RefString("view").Storable("order-raw-view");
    
    constructor(private _manager: OrdersManager, private orderId: string)
    {
        super("Raw order view");

        this.Content(async (body) => 
        {
            const order: Order | null = await this._manager.GetOne(this.orderId);

            if (!order)
            {
                this.Append(
                    new InfoBox("Błąd", `Nie znaleziono zamówienia`));
                return;
            }

            const steps = RefSerializer.Flatenize(order.Steps.Items.map(x => x.Data));
            const raw = new RefString(JSON.stringify(steps, null, 2));

            body.Append(
                new SmallHeader(`Kroki #${order.Id}`),
                new Select(this.view, ["edit", "view"]).WidthAuto(),
                // new HidingContentSwitcher(this.view)
                //     // .AddContent("edit", () => new MultilineInput(raw).Rows(32))
                //     .AddContent("view", () => new JsonViewer(flat)),
                // new Center(
                //     new DangerButton("Zapisz").OnClick(() => this._manager.Update(order))
                //         .VisibleWhen(this.view, v => v === "edit")
                // ).Margin(16)
                "Steps:",
                new JsonViewer(steps),
                "Meta:",
                new JsonViewer(order.Meta),
            );
        });
    }
}
